import React, { Component } from 'react';

class Whyedu extends Component {
    render() {
        return (
            <div>
                <section class="course-why-epn padding-default" id="course-why-epn">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2>Why edu plus now</h2>
                            <br />
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                        <img src="/assets/images/icons/whyepn1.svg" alt="whyepn1" />
                                        <h3>Industry-Ready Courses</h3>
                                        <p>Learn industry-relevant skills that’ll make your resume stand out and ensure
                                        you’re ready to
                                        tackle the job market.
                           </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                        <img src="/assets/images/icons/whyepn2.svg" alt="whyepn2" />
                                        <h3>Flexible Learning</h3>
                                        <p>Access online learning resources anywhere, anytime to gain valuable skills and
                                        transform your
                                        life in meaningful ways.
                           </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                        <img src="/assets/images/icons/whyepn3.svg" alt="whyepn3" />
                                        <h3>Qualified Instructors</h3>
                                        <p>Connect with experts and qualified instructors from reputed universities to stay
                                        on top of the
                                        ever-evolving future of work.
                           </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                        <img src="/assets/images/icons/whyepn4.svg" alt="whyepn4" />
                                        <h3>Adavanced study plans</h3>
                                        <p>Learn complex technical skills with videos, quizzes and assignments to develop
                                        your career and
                                        build towards a degree.
                           </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                        <img src="/assets/images/icons/whyepn5.svg" alt="whyepn5" />
                                        <h3>Focus on target</h3>
                                        <p>Select the best online courses in India that are not only informative and
                                        helpful to your
                                        long-term career goals but also help close the skill gap in the industry.
                           </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="box_feat">
                                        <img src="/assets/images/icons/whyepn6.svg" alt="whyepn6" />
                                        <h3>Knowledge Platform</h3>
                                        <p>Take advantage of a complete in-built environment for programming and get
                                        hands-on experience to
                                        solve real-world problems practically.
                           </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Whyedu;